import keywordAtom from '@src/recoils/atom/keyword';
import { useRouter } from 'next/router';
import React from 'react';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';

type Props = {
  isNotFound: boolean;
};

const NotFound = ({ isNotFound }: Props) => {
  const keyword = useRecoilValue(keywordAtom);
  const router = useRouter();

  return (
    <>
      <Container>
        <Wrap>
          {keyword && (
            <>
              <Title>{keyword}</Title>
              <SubTitle>에 대한 검색 결과가 없어요</SubTitle>
              <Description>
                검색어를 정확하게 입력하셨는지 확인해 보세요
              </Description>
            </>
          )}
          {router.pathname === '/community/donation' && isNotFound && (
            <div>아직 등록된 사연이 없어요.</div>
          )}
        </Wrap>
      </Container>
    </>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Wrap = styled.div`
  text-align: center;
`;

const Title = styled.div`
  color: ${({ theme }) => theme.commonColor.pink004};
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 24px;
`;

const SubTitle = styled.div`
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 16px;
`;

const Description = styled.div`
  color: ${({ theme }) => theme.commonColor.gray005};
  font-size: 18px;
`;

export default NotFound;
